import "core-js/modules/es.array.push.js";
import Store from "@/store/index";
import defaultSettings from "@/plugins/settings.js";
import BackMenu from "@/components/backmenu/index.vue";
import Footer from "@/components/footer/index.vue";
import Header from "@/components/header/index.vue";
export default {
  components: {
    BackMenu,
    Footer,
    Header
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true,
      result: [],
      isLoginshow: true,
      //主菜单
      isHomeShow: true,
      //返回菜单
      isFooterShow: true,
      //底部
      noHeaderPaths: ["/home", "/pay", "/pay-weixin", "/goods-search"],
      webConfigData: {} // 网站配置信息
    };
  },

  mounted() {
    // 获取网站配置信息
    this.$axios.get('/webConfig/getPcWebConfig').then(({
      data
    }) => {
      this.webConfigData = data;
      if (this.$route.path == '/detail') {
        document.title = '商品详情';
      } else if (this.$route.path == '/chat') {
        document.title = '在线客服';
      } else {
        document.title = this.webConfigData.pcTitleContentCn || defaultSettings.name;
      }
      localStorage.setItem('webConfig', JSON.stringify(data));
    });
  },
  watch: {
    // 监视路由信息对象
    $route: {
      handler(route) {
        //重置
        this.result = [];
        this.isLoginshow = true;
        this.isHomeShow = true;
        this.isFooterShow = true;
        if (this.noHeaderPaths.findIndex(item => item == route.path) != -1) {
          this.isHomeShow = false;
        }
        // 如果是首页/详情/政策咨询不适用header
        if (route.path == '/home' || route.path == '/detail' || route.path == '/information') {
          this.isLoginshow = false;
          this.isHomeShow = false;
          return;
        }
        if (route.path == '/chat') {
          this.isLoginshow = false;
          this.isHomeShow = false;
          this.isFooterShow = false;
          document.body.style.background = "#2e2f3d ";
          return;
        }
        // 业务流程不展示
        if (route.path == '/process-introduce') {
          this.isLoginshow = false;
          this.isHomeShow = false;
          this.isFooterShow = false;
          return;
        }
        if (route.path == '/login' || route.path == '/register') {
          this.isLoginshow = false;
          this.isHomeShow = false;
          this.isFooterShow = false;
          document.body.style.background = "#F4F8FF ";
          return;
        } else {
          document.body.style.background = "#fff";
        }
        // 由于未登录也可以查看首页、商品查询页、商品详情、所以此处关于主菜单、返回菜单、以及底部的判断暂时注释掉
        // if(!Store.state.token || Store.state.token == "undefined")
        // {
        //   this.isLoginshow=false
        //   this.isHomeShow= false
        //   this.isFooterShow = false
        //   return
        // }
        // 获取扁平化后的菜单数组
        let routerListFlat = JSON.parse(localStorage.getItem("routerListFlat") || []);
        //获取当前菜单的唯一id  例如2-3-1
        // let id= routerListFlat.filter((n) => n.path == route.path)[0].id
        let idArr = routerListFlat.filter(n => n.path == route.path);
        let id = "";
        if (idArr.length == 1) {
          id = idArr[0].id;
        } else {
          this.isLoginshow = true;
          this.isHomeShow = false;
          return;
        }
        // console.log(id);
        // 根据id获取完整菜单的id的数组  例如：[2,2-3,2-3-1]
        let routePathResult = [];
        let ids = id.split('-');
        for (let index = 0; index < ids.length; index++) {
          if (index == 0) {
            routePathResult.push(ids[index]);
          } else {
            routePathResult.push(routePathResult[index - 1] + '-' + ids[index]);
          }
        }
        // console.log(routePathResult)
        // 当前菜单id数组获取对应的routerName
        routePathResult.forEach(item => {
          let routerName = routerListFlat.filter(n => n.id == item)[0].routerName;
          this.result.push(routerName);
        });
      }
      // 默认执行一次
      // immediate: true,
    }
  },

  methods: {
    // 刷新当前页
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  }
};